import { render, staticRenderFns } from "./deficits.vue?vue&type=template&id=f32f7222&scoped=true"
import script from "./deficits.vue?vue&type=script&lang=js"
export * from "./deficits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32f7222",
  null
  
)

export default component.exports